import Button from '@/common/components/Button';
import { useFilterParams } from '@/common/hooks/useFilterParams';
import { reportFilters } from '@/features/reports/constants/reportFilters.constant';
import { XIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Control, FieldErrors, UseFormResetField, UseFormWatch } from 'react-hook-form';
import { PermittedReportFilterData } from '../types/permittedReports.type';

interface ReportsFiltersFieldProp {
  control: Control;
  errors: FieldErrors;
  filterName: string;
  filterProps: PermittedReportFilterData
  resetField: UseFormResetField<any>;
  watch: UseFormWatch<any>
}

const ReportsFiltersField = ({ control, errors, filterName, filterProps, resetField, watch }: ReportsFiltersFieldProp) => {
  const { filterParams, setFilterParams } = useFilterParams();

  const isCheckbox = filterName.endsWith('_is');

  const clientBranchValue = watch('client_branch_id_eq')

  const [defaultClientBranchValue, setDefaultClientBranchValue] = useState(filterParams?.q?.client_branch_id_eq);

  useEffect(() => {
    if (filterName.includes('client_equipment_id_eq') && clientBranchValue?.value !== defaultClientBranchValue?.value) {
      resetField('client_equipment_id_eq');
      setFilterParams((params) => ({ ...params, q: { ...params.q, 'client_equipment_id_eq': undefined } }));
      setDefaultClientBranchValue(undefined);
    }
  }, [clientBranchValue, filterName, defaultClientBranchValue]);

  return (
    <div className="flex w-full items-start">
      {(reportFilters[filterName as keyof typeof reportFilters] || (isCheckbox ? reportFilters['defaultCheckbox'] : reportFilters['default']))({
        control,
        errors,
        filterName,
        value: filterParams.q?.[filterName] || null,
        setFilterParams,
        filterProps,
      })}

      {!isCheckbox && (
        <Button
          type="button"
          variant="outline-error"
          className="size-[52px] px-2 mt-5 bg-black text-white-800 rounded-l-none"
          onClick={() => {
            resetField(filterName);
            setFilterParams((params) => ({ ...params, q: { ...params.q, [filterName]: undefined } }));
          }}
        >
          <XIcon className="size-5" />
        </Button>
      )}
    </div>
  );
};

export default ReportsFiltersField;
